import './styles/theme.scss';
import { CreateApp } from '@stl/index';
import urql from '@urql/vue';
import { urqlOptions } from '@/client/urql';
import App from '@/App.vue';
import router from '@/router';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus, faGlobe, faTrash, faPencil } from '@fortawesome/free-solid-svg-icons';

library.add(faPlus, faGlobe, faTrash, faPencil);
const app = CreateApp(App).use(router).use(urql, urqlOptions);

app.mount('#app');
